import { render, staticRenderFns } from "./GridEvents.vue?vue&type=template&id=3cd31fd4&"
import script from "./GridEvents.vue?vue&type=script&lang=js&"
export * from "./GridEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd31fd4')) {
      api.createRecord('3cd31fd4', component.options)
    } else {
      api.reload('3cd31fd4', component.options)
    }
    module.hot.accept("./GridEvents.vue?vue&type=template&id=3cd31fd4&", function () {
      api.rerender('3cd31fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/events/grid/GridEvents.vue"
export default component.exports